<template>
  <div class="text-center white--text">
    <v-menu v-model="menu" :close-on-content-click="true" offset-y v-if="currentOrganization">
      <template v-slot:activator="{ on }">
        <div v-on="on" class="pointer">
          <v-icon color="white">mdi-chevron-down</v-icon>
          <span class="body-2 font-weight-regular mr-3"> {{ currentOrganization.organizationName }}</span>
        </div>
      </template>
      <v-card v-if="currentOrganization"> 
        <v-list>
          <template v-for="row in organizationList">
            <v-list-item @click="switchOrg(row)">
              <v-list-item-content>
                <span>{{ row.Organization.organizationName }}</span>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <v-divider> </v-divider>
        <v-card-actions>
          <AttachOrg> </AttachOrg>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import AttachOrg from "./AttachOrg";

export default {
  name: "layout-menu",
  data() {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true
    };
  },
  components: {
    AttachOrg
  },

  computed: {
    ...mapGetters("global", ["currentOrganization", "currentUser", "organizationList"])
  },
  methods: {
    ...mapActions("global", ["selectedOrganization"]),
    switchOrg(data) {
      this.selectedOrganization(data.Organization);
      this.$router.go();
    },
    addOrg() {
      console.log("redssdfd");
    }
  }
};
</script>

<style scoped>
.br-50 {
  border-radius: 50%;
}
.menu-box {
  border: white solid 0.1em;
  padding: 7px;
  border-radius: 4px;
  cursor: pointer;
}
.menu-img {
  border-radius: 4px;
  width: 45px;
  height: 48px;
}
</style>
